let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aWeYx")).then(() => parcelRequire('5kIN6'));